/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as RichtextVideoFacet from "../richtext/videoFacet.defs.js";
import * as MediaDefs from "../media/defs.defs.js";
import * as StreamDefs from "../defs.defs.js";
import * as StreamVideo from "../video.defs.js";
import * as MetadataContentWarnings from "../metadata/contentWarnings.defs.js";
import * as MetadataContentRights from "../metadata/contentRights.defs.js";

const $nsid = "place.stream.vod.draftVideo";

export { $nsid };

/** A draft VOD: pre-publication video metadata and processing state. Modeled as a permissioned-data-style record (CBOR-serialized, addressed by an ats:// URI) stored in statedb until the permissioned-data spec ships (bluesky-social/proposals PR #94, the 0016-permissioned-data proposal). Publishing promotes it to a public place.stream.video record. */
type Main = { $type: "place.stream.vod.draftVideo";

  /**
   * Title of the video. May be a placeholder while processing; the user edits before publishing.
   */
  "title":string;

  /**
   * Description of the video.
   */
  "description"?:string;

  /**
   * Annotations of text (mentions, URLs, etc).
   */
  "descriptionFacets"?:(RichtextVideoFacet.Main)[];

  /**
   * Thumbnail image. Generated by the server at publish time if absent.
   */
  "thumb"?:l.BlobRef;

  /**
   * Source tracks. Filled by the server when processing completes (status 'ready').
   */
  "source"?:l.$Typed<MediaDefs.SourceTracks> | l.$Typed<MediaDefs.SourceClip> | l.Unknown$TypedObject;

  /**
   * Duration in milliseconds. Filled when status is 'ready'.
   */
  "durationMs"?:number;

  /**
   * The game or activity in the video.
   */
  "activity"?:l.$Typed<StreamDefs.ActivityGame> | l.$Typed<StreamDefs.ActivityLabel> | l.Unknown$TypedObject;

  /**
   * Freeform tags (same rules as place.stream.video).
   */
  "tags"?:(string)[];

  /**
   * Related records (e.g. the source livestream for a finalized VOD).
   */
  "connections"?:(l.$Typed<StreamVideo.Connection> | l.Unknown$TypedObject)[];"contentWarnings"?:MetadataContentWarnings.Main;"contentRights"?:MetadataContentRights.Main;

  /**
   * Processing state: 'processing' while the job runs, 'ready' when publishable, 'error' if processing failed.
   */
  "status":"processing" | "ready" | "error" | l.UnknownString;

  /**
   * Error message when status is 'error'.
   */
  "error"?:string;"createdAt":l.DatetimeString };

export type { Main };

/** A draft VOD: pre-publication video metadata and processing state. Modeled as a permissioned-data-style record (CBOR-serialized, addressed by an ats:// URI) stored in statedb until the permissioned-data spec ships (bluesky-social/proposals PR #94, the 0016-permissioned-data proposal). Publishing promotes it to a public place.stream.video record. */
const main = /*#__PURE__*/ l.record<"tid", Main>("tid", $nsid, /*#__PURE__*/ l.object({"title":/*#__PURE__*/ l.string({"maxLength":1400,"maxGraphemes":140}),"description":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":50000,"maxGraphemes":5000})),"descriptionFacets":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<RichtextVideoFacet.Main>((() => RichtextVideoFacet.main) as any), )),"thumb":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.blob({"accept":["image/*"],"maxSize":1000000})),"source":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<MediaDefs.SourceTracks>((() => MediaDefs.sourceTracks) as any),/*#__PURE__*/ l.typedRef<MediaDefs.SourceClip>((() => MediaDefs.sourceClip) as any)], false)),"durationMs":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"activity":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<StreamDefs.ActivityGame>((() => StreamDefs.activityGame) as any),/*#__PURE__*/ l.typedRef<StreamDefs.ActivityLabel>((() => StreamDefs.activityLabel) as any)], false)),"tags":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.string({"maxLength":640,"maxGraphemes":64}), {"maxLength":10})),"connections":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<StreamVideo.Connection>((() => StreamVideo.connection) as any)], false), )),"contentWarnings":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<MetadataContentWarnings.Main>((() => MetadataContentWarnings.main) as any)),"contentRights":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<MetadataContentRights.Main>((() => MetadataContentRights.main) as any)),"status":/*#__PURE__*/ l.string<{"knownValues":["processing","ready","error"]}>(),"error":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"createdAt":/*#__PURE__*/ l.string({"format":"datetime"})}));

export { main };

export const $type = $nsid;
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);
